// extracted by mini-css-extract-plugin
export var box = "TextAndImage-module--box--Ybnxs";
export var image = "TextAndImage-module--image--dG-Q2";
export var text = "TextAndImage-module--text--VMvrx";
export var wrapper = "TextAndImage-module--wrapper--Nj0+I";